export const API_BASE_URL =
  import.meta.env.VITE_API_BASE_URL || 'https://dev.admin.nobrinde.immera.io'

export const VENDURE_AUTH_TOKEN_HEADER_KEY = 'vendure-auth-token'
export const VENDURE_CHANNEL_TOKEN_HEADER_KEY = 'vendure-channel-token'
export const VENDURE_LANGUAGE_CODE_HEADER_KEY = 'vendure-language-code'
